import { gql } from '@apollo/client';
import Task from "../../fragments/Projects/Task";
import ErrorResultFragment from "../../fragments/ErrorResult";

const CREATE_TASK = gql`
  mutation CreateTask(
    $createTaskParams: CreateTaskParamsInput!
    $task: TaskInput!
  ) {
    projects {
      createTask(
        createTaskParams: $createTaskParams
        task: $task
      ) {
        success
        errorResult { ...ErrorResultFields }
        task { ...Task }
      }
    }
  }
  ${Task}
  ${ErrorResultFragment}
`;

export default CREATE_TASK;
